import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageClientDetail } from "@components/modules/clients/detail/PageClientDetail";
import { NavigationClient } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Client detail`}
    navigation={<NavigationClient id={id} variant="panel" />}
  >
    <PageClientDetail />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/clients/detail")({
  component: RouteComponent,
});
